//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { AccessGuids, ConfigSystemParams } from 'src/app/core/consts';
import { ComponentAccessUserService } from '../system/component-access/component-access-user-service';
import { ConfigSystemService } from '../system/config-system/config-system-service';
import { ExceptionsService } from './exceptions-service';
import { Injectable, OnDestroy } from '@angular/core';

@Injectable({ providedIn: 'root' })

export class LastPassKillerService implements OnDestroy {
  
  get killerEnabled() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormLastPassKillerEnabled, true)&&
                               !this.componentAccessUserService.hasAccessGuid(AccessGuids.FormGeneralLastPassKillerGuard, true); }
  
  private observer?  : MutationObserver;
  private running    : boolean=false;
  private sweepTimer?: ReturnType<typeof setInterval>;
  
  private readonly selectors: string[]=[
    'div[data-lastpass-root]',
    'div[data-lastpass-icon-root]',
    '[data-lastpass-root]',
    '[data-lastpass-icon-root]',
    'iframe[src*="lastpass"]',
  ]; 
  
  constructor(
    private componentAccessUserService: ComponentAccessUserService,
    private configSystemService       : ConfigSystemService,
    private exceptionsService         : ExceptionsService
  ) {
  
  }

  public ngOnDestroy(): void {
    try {
      this.stop();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public start(): void {
    try {
      if (!this.killerEnabled) {
        this.stop();
        return;
      }

      if (this.running)
        return;
      
      this.running=true;
      
      this.sweep();
      
      this.observer=new MutationObserver(() => this.sweep());

      this.observer.observe(document.body, { childList: true, subtree: true });
      
      this.sweepTimer=setInterval(() => this.sweep(), 400); 
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public stop(): void {
    try {
      this.running=false;
      
      try {
        this.observer?.disconnect();
      }
      catch {
        //CRN_20251013 - ⚠️ Do not toast error, message was appearing 'not connected' ⚠️
      }
      
      this.observer=undefined;

      if (this.sweepTimer)
        clearInterval(this.sweepTimer);

      this.sweepTimer=undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      this.sweepTimer=undefined;
    }
  }
  
  private sweep(): void {
    try {
      for (const sel of this.selectors) {
        document.querySelectorAll(sel).forEach((el) => {
          //CRN_20251119 - Original method
          // const root=(el as any).getRootNode?.();
          
          // if (!(root instanceof ShadowRoot)) {
          //   el.remove();
          // }

          try {
            //CRN_20251119 - Remove element regardless of any condition
            el.remove();
          } catch {
            //CRN_20251119 - Ignore individual failures & continue loop
          }
        });
      }
    } catch {
      //CRN_20251013 - ⚠️ Do not toast error, Lastpass icon may not exist ⚠️
    }
  }
}
